import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const GroupService = {
    getGroupById: (id) => {
        return http.get(`${baseUrl}/cliami/groups/${id}`);
    },

    getGroups: () => {
        return http.get(`${baseUrl}/cliami/groups`);
    },

    saveGroup: (group) => {
        if (!group.groupId) {
            return http.post(`${baseUrl}/cliami/groups/create`, group);
        } else {
            return http.put(`${baseUrl}/cliami/groups/update/${group.groupId}`, group);
        }
    },

    deleteGroup: (group) => {
        return http.delete(`${baseUrl}/cliami/groups/delete/${group.groupId}`);
    },
};

export default GroupService;
